<template>
  <v-container id="city-get" class="propostas">
    <city-header :payload="municipio"> </city-header>
    <v-row>
      <v-col class="titulos">
        <h3>Propostas</h3>
        <div class="dadosCadastrais">
          <ModalDadosCadastrais
            :dadosPayload="dados"
            :disabled="dados && !dados.cnpj"
          >
            <template v-slot:title> Dados Cadastrais </template>
          </ModalDadosCadastrais>
        </div>
        <template v-if="municipio && municipio.faixaId">
          <div
            v-if="
              isFullAdmin ||
              (config.gerarEditarProposta && groupsConfig.gerarEditarProposta)
            "
          >
            <NovaProposta
              :payload="{ color: 'error' }"
              @onLoad="list()"
              :possuiPropostaEmProcessamento="possuiPropostaEmProcessamento"
              :combos="combos"
              :faixa="faixa"
            >
              <template v-slot:title> Gerar Nova Proposta </template>
            </NovaProposta>
            <!-- <NovaPropostaMA
            :payload="{ color: 'error' }"
            @onLoad="list()"
            :possuiPropostaEmProcessamento="possuiPropostaEmProcessamento"
          >
            <template v-slot:title> Gerar Nova Proposta </template>
          </NovaPropostaMA> -->
          </div>
        </template>
      </v-col>
    </v-row>
    <v-row v-if="(municipio && !municipio.faixaId) || !municipio">
      <v-col>
        É necessário adicionar uma faixa ao município para calcular os valores
        da proposta.
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="propostas"
          class="elevation-1 w-100 proposta"
          hide-default-footer
          disable-pagination
          :expanded.sync="expanded"
          single-expand
          show-expand
          item-key="municipioPropostaId"
        >
          <template v-slot:item.download="{ item }">
            <div
              style="display: flex; justify-content: center; column-gap: 10px"
            >
              <v-btn
                color="primary"
                class="ml-3"
                @click="downloadProposta(item.municipioPropostaId)"
              >
                <span>Baixar Proposta</span>
              </v-btn>

              <template
                v-if="
                  item.status == enumStatusPropostas.aprovado ||
                  item.status == enumStatusPropostas.execucaoIniciada
                "
              >
                <modalAnalisar
                  :payload="{
                    color: 'success',
                    baixarMinuta: true,
                    disabled: dados && !dados.cnpj,
                    ...item,
                  }"
                  @baixarMinuta="downloadMinuta(item.municipioPropostaId)"
                >
                  <template v-slot:title> Baixar minuta do contrato </template>
                </modalAnalisar>
              </template>
            </div>
          </template>

          <template v-slot:item.analyse="{ item }">
            <div style="display: flex">
              <template
                v-if="item.status == enumStatusPropostas.emProcessamento"
              >
                <modalAnalisar
                  :payload="{ color: 'error', ...item, rejeitar: true }"
                  @onLoad="list()"
                >
                  <template v-slot:title> Rejeitar Proposta </template>
                </modalAnalisar>

                <modalAnalisar
                  :payload="{ color: 'success', aceitar: true, ...item }"
                  @onLoad="list()"
                >
                  <template v-slot:title> Aprovar Proposta </template>
                </modalAnalisar>
              </template>
            </div>
            <template
              v-if="item.status == enumStatusPropostas.execucaoIniciada"
            >
              <div>
                Execução iniciada dia
                {{ item.dataExecucao | moment("DD/MM/YYYY") }}
              </div>
            </template>
            <template
              v-if="
                item.status == enumStatusPropostas.aprovado &&
                (isFullAdmin ||
                  (config.podeExcluirProposta &&
                    groupsConfig.podeExcluirProposta))
              "
            >
              <div style="display: flex; column-gap: 10px">
                <modalAnalisar
                  :payload="{
                    color: 'success',
                    iniciar: true,
                    disabled: dados && !dados.cnpj,
                    ...item,
                  }"
                  @onLoad="list()"
                >
                  <template v-slot:title> Iniciar Execução </template>
                </modalAnalisar>
              </div>
            </template>
            <template v-if="item.status == enumStatusPropostas.rejeitado">
              <img src="assets/img/noEvidence.png" style="width: 30px" />
            </template>
          </template>

          <template v-slot:item.acoes="{ item }">
            <modalDelete
              :payload="item"
              @onLoad="list()"
              v-if="
                isFullAdmin ||
                (config.podeExcluirProposta && groupsConfig.podeExcluirProposta)
              "
            >
              <template v-slot:title> Deletar Proposta </template>
            </modalDelete>
            <template v-if="item.status != enumStatusPropostas.emProcessamento">
              <v-btn
                color="primary"
                class="mr-3"
                @click="reverter(item)"
                v-if="
                  isFullAdmin ||
                  (config.reverterProposta && groupsConfig.reverterProposta)
                "
              >
                Reverter
              </v-btn>
            </template>
          </template>

          <template
            v-slot:item.data-table-expand="{ expand, isExpanded, item }"
          >
            <template
              v-if="item.status == enumStatusPropostas.execucaoIniciada"
            >
              <div style="display: flex; column-gap: 5px">
                <v-btn
                  color="primary"
                  class="mr-3"
                  @click="
                    itemExpand = !itemExpand;
                    expand(itemExpand);
                  "
                >
                  Anexos
                  <v-icon v-if="isExpanded">mdi-chevron-up</v-icon>
                  <v-icon v-else>mdi-chevron-down</v-icon>
                </v-btn>
              </div>
            </template>
          </template>

          <template slot="no-data">
            <span> Nenhuma proposta retornada </span>
          </template>

          <template v-slot:expanded-item="props">
            <td colspan="6" style="background: #f5f5f5">
              <AnexosList
                :payload="{
                  ...props.item,
                }"
                @reload="list"
                :municipio="municipio"
              ></AnexosList>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import CityHeader from "@/modules/city/components/Header";
import modalDelete from "./modalDelete.vue";
import modalAnalisar from "./modalAnalisar.vue";
import NovaProposta from "./novaProposta.vue";
import NovaPropostaMA from "./novaPropostaMA.vue";
import moment from "moment";
import ModalDadosCadastrais from "./modalDadosCadastrais";
import {
  propostaApi,
  municipioPropostaDadosApi,
  municipioPropostaComboApi,
} from "@/apis";
import { statusPropostasEnum } from "./statusPropostasEnum";
import { cityAPI } from "@/modules/city";
import { faixaApi } from "@/apis";
import AnexosList from "./anexos/AnexosList.vue";

export default {
  name: "ListaProposta",

  components: {
    CityHeader,
    modalDelete,
    modalAnalisar,
    NovaProposta,
    ModalDadosCadastrais,
    NovaPropostaMA,
    AnexosList,
  },
  computed: {
    ...mapGetters(["isFullAdmin"]),
  },
  mounted() {
    if (
      this.isFullAdmin ||
      (this.config.podeExcluirProposta &&
        this.groupsConfig.podeExcluirProposta) ||
      (this.config.reverterProposta && this.groupsConfig.reverterProposta) ||
      (this.config.gerarEditarProposta && this.groupsConfig.gerarEditarProposta)
    ) {
      this.headers.push({ text: "Ações", value: "acoes", align: "center" });
    }

    this.list();
  },
  data() {
    return {
      expanded: [],
      itemExpand: false,
      headers: [
        { text: "Número", value: "municipioPropostaId" },
        { text: "Status", value: "status" },

        { text: "Analisar", value: "analyse" },
        { text: "Download", value: "download", align: "center" },
        { text: "", value: "data-table-expand" },
      ],
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      propostas: [],
      municipioId: this.$route.params.id,
      enumStatusPropostas: statusPropostasEnum,
      possuiPropostaEmProcessamento: false,
      dados: null,
      combos: [],
      municipio: null,
      faixa: null,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    downloadMinuta(propostaId) {
      this.setLoading(true);
      propostaApi
        .downloadMinuta(propostaId)
        .then((data) => {
          this.$notification.success("Minuta de contrato gerada com sucesso!");
          this.fazerDownloadRelatorio(
            data.data,
            `Minuta do contrato - ${this.municipio.nome}`
          );

          this.$emit("onLoad");
        })
        .catch((err) => {
          this.$notification.error("Erro ao gerar Minuta de contrato");
          console.log("Erro no delete ", err);
          this.setLoading(false);
        });
    },
    downloadProposta(propostaId) {
      this.setLoading(true);
      propostaApi
        .downloadProposta(propostaId)
        .then((data) => {
          this.$notification.success("Proposta gerada com sucesso!");
          this.fazerDownloadRelatorio(
            data.data,
            `Proposta - ${this.municipio.nome}`
          );

          this.$emit("onLoad");
        })
        .catch((err) => {
          this.$notification.error("Erro ao gerar Proposta");
          console.log("Erro no delete ", err);
          this.setLoading(false);
        });
    },
    fazerDownloadRelatorio(file, nomeArquivo) {
      var fileURL = window.URL.createObjectURL(new Blob([file]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute(
        "download",
        `${nomeArquivo} - ${moment().format("DD.MM.YYYY.HH.mm")}.pdf`
      );

      document.body.appendChild(fileLink);
      fileLink.click();
      this.setLoading(false);
    },
    list() {
      this.setLoading(true);
      propostaApi
        .getPropostasPorMunicipioId(this.municipioId)
        .then((data) => {
          this.propostas = data.data;
          this.possuiPropostaEmProcessamento = !!this.propostas.find(
            (item) => item.status == statusPropostasEnum.emProcessamento
          );

          this.getDados();
        })
        .catch((err) => {
          this.$notification.error("Erro ao listar Proposta");
          console.log("Erro no delete ", err);
          this.setLoading(false);
        });
    },
    reverter(item) {
      this.setLoading(true);

      item.status = statusPropostasEnum.emProcessamento;
      propostaApi
        .update(item)
        .then(() => {
          this.$notification.success("Proposta revertida com sucesso");
          this.list();
          this.setLoading(false);
        })
        .catch((err) => {
          this.$notification.error("Erro ao reverter Proposta");
          console.log("Erro no delete ", err);
          this.setLoading(false);
        });
    },
    async getDados() {
      this.setLoading(true);
      municipioPropostaDadosApi
        .getDadosPorMunicipioId(this.municipioId)
        .then((resp) => {
          this.dados = (resp.data && resp.data.length && resp.data[0]) || {};
          this.getCombos();
        })
        .catch((err) => {
          this.$notification.error("Erro ao obter os Dados cadastrais");
          console.log("Erro no delete ", err);
          this.setLoading(false);
        });
    },
    async getCombos() {
      this.setLoading(true);
      municipioPropostaComboApi
        .list()
        .then((resp) => {
          this.combos = resp.data;
          this.loadCity();
        })
        .catch((err) => {
          this.$notification.error("Erro ao obter dados dos combos");
          console.log("Erro no getCombos ", err);
          this.setLoading(false);
        });
    },
    loadCity() {
      this.setLoading(true);

      cityAPI
        .get(this.municipioId)
        .then((resp) => {
          this.municipio = resp.data;

          if (this.municipio.faixaId)
            this.loadFaixasByCity(this.municipio.faixaId);
          else this.setLoading(false);
        })
        .catch((err) => {
          this.$notification.error("Erro ao obter dados do município");
          console.log("Erro no loadCity ", err);
          this.setLoading(false);
        });
    },

    loadFaixasByCity(faixaId) {
      faixaApi
        .get(faixaId)
        .then((res) => {
          this.faixa = res.data;

          this.setLoading(false);
        })
        .catch((err) => {
          this.$notification.error("Erro ao obter dados da faixa");
          console.log("Erro no loadFaixasByCity ", err);
          this.setLoading(false);
        });
    },
  },
};
</script>
<style lang="scss">
.propostas {
  .titulos {
    display: flex;
    justify-content: space-between;
    .dadosCadastrais {
      margin-left: auto;
    }
  }
  .proposta {
    width: 100%;
    th {
      background-color: var(--corPrimaria);
      span {
        color: #fff;
        font-size: 14px;
      }
    }
    tbody {
      tr:nth-child(odd) {
        background-color: #a1c2e014;
      }
    }
  }
}
</style>
<style lang="scss"></style>
